// extracted by mini-css-extract-plugin
module.exports = {"pane":"EventCalendarControl_pane__FFWbD","paneSmall":"EventCalendarControl_paneSmall__bUmgn","info":"EventCalendarControl_info__pOJF2","dates":"EventCalendarControl_dates__RdxKb"};